// import React, { useState } from "react";

// import {
//   Button,
//   Checkbox,
//   Form,
//   Grid,
//   Input,
//   message,
//   Spin,
//   theme,
//   Typography,
// } from "antd";

// import {
//   ArrowRightOutlined,
//   LoadingOutlined,
//   LockOutlined,
//   MailOutlined,
//   SyncOutlined,
//   UserOutlined,
// } from "@ant-design/icons";
// import { Link } from "react-router-dom";
// import { forgetPassword } from "../Service/forgetPassword";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function ForgetPassword() {
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const [resMessage, setResMessage] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = (values) => {
//     setIsLoading(true);

//     forgetPassword(values)
//       .then((res) => {
//         messageApi.open({
//           type: "success",
//           content: res.data.message,
//         });
//         setResMessage(res.data.message);
//       })
//       .catch((err) => {
//         messageApi.open({
//           type: "error",
//           content: err.response.data,
//         });
//       })
//       .finally(() => {
//         setIsLoading(false);
//       });
//   };

//   const styles = {
//     // container: {
//     //   margin: "0 auto",
//     //   padding: screens.md
//     //     ? `${token.paddingXL}px`
//     //     : `${token.sizeXXL}px ${token.padding}px`,
//     //   width: "300px",
//     // },
//     container: {
//       backgroundColor: "rgba(240, 240, 240, 0.2)", // Transparent white with some opacity.
//       // backgroundColor: "#4c5270",
//       // opacity:".8",
//       borderRadius: "10px",
//       backdropFilter: "blur(28px)", // Optional for visual effect.
//       padding: "1rem", // Inner padding.
//       padding: screens.md
//         ? `${token.paddingXL}px`
//         : `${token.sizeXXL}px ${token.padding}px`,
//       width: "auto", // Remove the fixed width for better flexibility.
//       alignSelf: "flex-end", // Align the `div` itself to the right if needed.
//       width: "350px",
//       // height:"300px"
//     },
//     footer: {
//       marginTop: token.marginLG,
//       textAlign: "center",
//       width: "100%",
//     },
//     forgotPassword: {
//       paddingTop: "10px",
//       float: "right",
//       color: "white",
//     },
//     header: {
//       marginBottom: token.marginXL,
//     },
//     // section: {
//     //   alignItems: "center",
//     //   backgroundColor: token.colorBgContainer,
//     //   display: "flex",
//     //   height: screens.sm ? "100vh" : "auto",
//     //   padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
//     // },
//     section: {
//       backgroundColor: token.colorBgContainer,
//       display: "flex",
//       flexDirection: "column", // For vertical stacking; change to "row" if you want a horizontal layout.
//       justifyContent: "center", // Vertically centers items.
//       alignItems: "flex-end", // Aligns items horizontally to the right.
//       minHeight: "100vh", // Ensures full viewport height.
//       backgroundPosition: "center",
//       backgroundSize: "cover",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//       width: "100%", // Ensures the section spans the full width.
//     },
//     text: {
//       color: "white",
//     },
//     title: {
//       fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
//     },
//   };

//   return (
//     // <section style={{...styles.section,backgroundImage:"url('retail_edge_background_image')"}}>

//     <section
//       style={{
//         ...styles.section,
//         // backgroundPosition: "center",
//         // backgroundSize: "cover",
//         // backgroundColor: "black",
//         backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//       }}
//     >
//       {contextHolder}
//       <div
//         style={{
//           ...styles.container,
//           // backgroundColor: "rgba(240, 240, 240, 0.2)", // Black with 0.9 opacity
//           // color: "white",
//           // borderRadius: "10px",
//           // backdropFilter: "blur(4px)", // Optional for adding a subtle blur
//           // padding: "1rem", // Optional padding for a better look
//         }}
//       >
//         <div
//           style={{
//             textAlign: "center",
//             paddingBottom: "1rem",
//             display: "flex",
//             width: "100%",
//             justifyContent: "center",
//             color: "white",
//           }}
//         >
//           <img
//             src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//             alt="Logo"
//             style={{
//               width: "2rem",
//               height: "auto",
//               borderRadius: "50%",
//               marginRight: "10px",
//             }}
//           />
//           <h2>Step to Innovation</h2>
//         </div>
//         <Form
//           name="normal_login"
//           initialValues={{
//             remember: true,
//           }}
//           onFinish={onFinish}
//           layout="vertical"
//           requiredMark="optional"
//         >
//           {resMessage ? (
//             <h1
//               style={{
//                 textAlign: "center",
//                 paddingBottom: "2rem",
//               }}
//             >
//               {/* {resMessage} */}
//               We've emailed a password reset link. Please check your inbox or
//               spam folder.
//             </h1>
//           ) : (
//             <>
//               <Form.Item
//                 name="email"
//                 label={
//                   <div style={{ color: "#d3d5dfff", fontWeight: "600" }}>
//                     EMAIL
//                   </div>
//                 }
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Email!",
//                   },
//                 ]}
//               >
//                 <Input
//                   prefix={<MailOutlined />}
//                   type=""
//                   placeholder="Email"
//                   style={{ padding: "8px 12px" }}
//                 />
//               </Form.Item>

//               <Form.Item style={{ marginBottom: "0px" }}>
//                 <Button
//                   block="true"
//                   type="primary"
//                   htmlType="submit"
//                   style={{
//                     padding: "20px 12px",
//                     backgroundColor: isLoading ? "#1677ff" : undefined,
//                     borderColor: isLoading ? "#1677ff" : undefined,
//                     cursor: isLoading ? "not-allowed" : undefined,
//                   }}
//                   disabled={isLoading}
//                   icon={
//                     <Spin
//                       spinning={isLoading}
//                       indicator={<SyncOutlined spin />}
//                       // size="small"
//                       style={{ color: "white" }}
//                     />
//                   }
//                 >
//                   {!isLoading ? "Submit" : ""}
//                 </Button>
//               </Form.Item>
//               <Button
//                 style={{
//                   background: "transparent",
//                   border: "none",
//                   padding: "5px",
//                   float: "right",
//                   marginTop: "10px",
//                 }}
//                 disabled={isLoading}
//               >
//                 <Link
//                   to="/login"
//                   style={{
//                     float: "left",
//                     color: "#d3d5dfff",
//                   }}
//                 >
//                   Login
//                   <ArrowRightOutlined
//                     style={{ paddingLeft: "3px", marginTop: "7px" }}
//                   />
//                 </Link>
//               </Button>
//             </>
//           )}
//         </Form>
//       </div>
//     </section>
//   );
// }
import React, { useState } from "react";
import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
import {
  ArrowRightOutlined,
  MailOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { forgetPassword } from "../Service/forgetPassword";

const { useToken } = theme;
const { useBreakpoint } = Grid;

export default function ForgetPassword() {
  const { token } = useToken();
  const screens = useBreakpoint();

  const [resMessage, setResMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    setIsLoading(true);

    forgetPassword(values)
      .then((res) => {
        messageApi.open({
          type: "success",
          content: res.data.message,
        });
        setResMessage(res.data.message);
      })
      .catch((err) => {
        messageApi.open({
          type: "error",
          content: err.response?.data || "Server error",
        });
      })
      .finally(() => setIsLoading(false));
  };

  /* 🔹 SAME STYLES AS LOGIN */
  const styles = {
    section: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
    },

    container: {
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
      padding: "40px",
      width: "420px",
    },

    header: {
      textAlign: "center",
      marginBottom: "32px",
    },

    subtitle: {
      fontSize: "14px",
      color: "#718096",
    },

    label: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#2d3748",
    },

    input: {
      padding: "12px 16px",
      borderRadius: "8px",
      fontSize: "16px",
    },

    button: {
      height: "48px",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: "8px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
    },

    backToLogin: {
      marginTop: "16px",
      textAlign: "center",
      display: "block",
      color: "#667eea",
      fontSize: "14px",
      fontWeight: 500,
    },

    successText: {
      textAlign: "center",
      fontSize: "16px",
      color: "#2d3748",
      lineHeight: "1.6",
    },
  };

  return (
    <>
      {contextHolder}
      <section
        style={{
          ...styles.section,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
        }}
      >
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{
                  width: "5rem",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />
              <h2>Step to Innovation</h2>
            </div>
            <p style={styles.subtitle}>
              Enter your email to reset your password
            </p>
          </div>

          {/* Form */}
          <Form
            name="forget_password"
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
          >
            {resMessage ? (
              <p style={styles.successText}>
                We've emailed a password reset link. Please check your inbox or
                spam folder.
              </p>
            ) : (
              <>
                <Form.Item
                  name="email"
                  label={<span style={styles.label}>Email Address</span>}
                  rules={[
                    { required: true, message: "Please input your email!" },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined />}
                    placeholder="Enter your email"
                    style={styles.input}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    style={styles.button}
                    disabled={isLoading}
                    icon={
                      isLoading ? (
                        <Spin
                          indicator={<SyncOutlined spin />}
                          style={{ color: "white" }}
                        />
                      ) : null
                    }
                  >
                    {!isLoading && "Submit"}
                  </Button>
                </Form.Item>

                <Link to="/login" style={styles.backToLogin}>
                  Back to Login <ArrowRightOutlined />
                </Link>
              </>
            )}
          </Form>
        </div>
      </section>
    </>
  );
}
